export default __webpack_public_path__ + "static/bergen-thumbnail-2e40f1586fab92b115513bc63ab4cd45.webp";